import './style.scss'
import React from 'react'
import { tokens } from 'src/componentv2/Base/ui'

export interface CircularProgressProps {
    value?: number               // 0..100
    size?: number                // px
    stroke?: number              // px
    color?: string
    trackColor?: string
    label?: React.ReactNode      // centre text; defaults to "<value>%"
    caption?: React.ReactNode    // text under the ring
    className?: string
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
                                                                      value = 0, size = 64, stroke = 6,
                                                                      color = tokens.primary, trackColor = '#EAECF0',
                                                                      label, caption, className = '',
                                                                  }) => {
    const pct = Math.max(0, Math.min(100, value))
    const r = (size - stroke) / 2
    const c = 2 * Math.PI * r
    const offset = c - (pct / 100) * c

    return (
        <div className={`circular ${className}`}>
            <div className="circular__ring" style={{ width: size, height: size }}>
                <svg width={size} height={size}>
                    <circle
                        cx={size / 2} cy={size / 2} r={r}
                        fill="none" stroke={trackColor} strokeWidth={stroke}
                    />
                    <circle
                        cx={size / 2} cy={size / 2} r={r}
                        fill="none" stroke={color} strokeWidth={stroke}
                        strokeLinecap="round"
                        strokeDasharray={c}
                        strokeDashoffset={offset}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                </svg>
                <span className="circular__label">
                    {label ?? `${Math.round(pct)}%`}
                </span>
            </div>
            {caption && <span className="circular__caption">{caption}</span>}
        </div>
    )
}

export default CircularProgress